import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";

export const StoryPreview = ({ farmId, farmName, storyPreview, className }) => {
  // Ensure story is within 120 words
  const truncatedStory = storyPreview ? 
    storyPreview.split(' ').slice(0, 120).join(' ') + (storyPreview.split(' ').length > 120 ? '...' : '') 
    : '';

  return (
    <div className={cn("bg-secondary/30 rounded-xl p-6 border border-border", className)}>
      <div className="flex items-center gap-2 mb-4">
        <div className="p-2 bg-secondary rounded-lg">
          <BookOpen className="h-5 w-5 text-foreground" />
        </div>
        <h3 className="font-display text-lg font-medium text-foreground">The Story</h3>
      </div>
      
      <p className="text-muted-foreground leading-relaxed mb-4">
        {truncatedStory}
      </p>

      <Button asChild variant="link" className="p-0 h-auto gap-1 text-foreground">
        <Link to={`/farm-stories/${farmId}`}>
          Read the full story from {farmName}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </Button>
    </div>
  );
};
